var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nuxt-link",
    { staticClass: "c-nav-card-featured", attrs: { to: _vm.navItem.linkUrl } },
    [
      _vm.navItem
        ? [
            _c(
              "div",
              { staticClass: "l-flex l-flex--align-evenly l-flex__nowrap" },
              [
                _c(
                  "div",
                  { staticClass: "c-nav-card-featured__left l-flex__item" },
                  [
                    _c("div", { staticClass: "c-nav-card-featured__header" }, [
                      _c("header", { staticClass: "t-heading-8" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.navItem.title) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.navItem.linkText && _vm.navItem.linkText.length > 0
                      ? _c(
                          "header",
                          {
                            staticClass:
                              "c-nav-card-featured__subheader t-heading-8"
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.navItem.linkText) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "l-flex__item" }, [
                  _c("img", {
                    staticClass: "c-nav-card-featured__image",
                    attrs: {
                      src: _vm.navItem.image.src,
                      alt: _vm.navItem.image.alt
                    }
                  })
                ])
              ]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }